// Cleanup old reservations client-side (used by admin dashboard).
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "./firebase";

export async function cleanupOldReservations() {
  try {
    const now = new Date();
    const today = now.toISOString().split("T")[0];
    const currentTime = now.toTimeString().slice(0, 5);

    const snapshot = await getDocs(collection(db, "reservations"));
    let deletedCount = 0;
    for (const docSnap of snapshot.docs) {
      const r = docSnap.data();
      const past =
        (r.date && r.date < today) ||
        (r.date === today && r.time && r.time < currentTime);
      if (past) {
        try { await deleteDoc(doc(db, "reservations", docSnap.id)); deletedCount += 1; } catch (e) { /* skip */ }
      }
    }
    return { success: true, deletedCount };
  } catch (e) {
    console.error("cleanup error", e);
    return { success: false, error: e.message };
  }
}
